var calculateTotal;

if (libraries.chartist) {
  calculateTotal = function(data) {
    var series;
    series = Chartist.getDataArray(ko.unwrap(data));
    return (series.reduce(function(prev, curr) {
      return prev + curr;
    })) * 2;
  };
  $.fn.chart = function(options) {
    var isGuage;
    options = $.extend({
      type: 'Line',
      isLoading: false,
      isErrored: false,
      data: {},
      getLoadingMessageHtml: function() {
        return 'fetching data&hellip;';
      },
      getEmptyMessageHtml: function() {
        return 'No data at this time.';
      },
      getErrorMessageHtml: function() {
        return 'Unable to fetch data.';
      },
      chartOptions: {
        fullWidth: true,
        chartPadding: {
          right: 20
        },
        lineSmooth: false
      },
      responsiveOptions: {}
    }, options);
    if (options.type === 'Donut') {
      options.type = 'Pie';
      options.chartOptions.donut = true;
      options.chartOptions.donutWidth = '30%';
    }
    isGuage = false;
    if (options.type === 'Guage') {
      isGuage = true;
      options.type = 'Pie';
      options.chartOptions.donut = true;
      options.chartOptions.donutWidth = '30%';
      options.chartOptions.startAngle = 270;
      options.chartOptions.total = calculateTotal(options.data);
    }
    $(this).each(function(idx, element) {
      var $element, $messageContainer, _hidehideAndShowMessages, chart;
      $element = $(element);
      $element.addClass('ct-chart');
      $messageContainer = $('<div class="message hide"></div>');
      $messageContainer.appendTo(element);
      chart = Chartist[options.type](element, ko.unwrap(options.data), options.chartOptions, options.responsiveOptions);
      _hidehideAndShowMessages = ko.computed(function() {
        var d;
        if (ko.unwrap(options.isLoading)) {
          $messageContainer.show();
          return $messageContainer.html(options.getLoadingMessageHtml);
        } else if (ko.unwrap(options.isErrored)) {
          $messageContainer.show();
          return $messageContainer.html(options.getErrorMessageHtml);
        } else {
          d = ko.unwrap(options.data);
          if (!d || !d.series || d.series.length < 1) {
            $messageContainer.show();
            return $messageContainer.html(options.getEmptyMessageHtml);
          } else {
            return $messageContainer.fadeOut();
          }
        }
      });
      if (ko.isObservable(options.data)) {
        return options.data.subscribe(function(newValue) {
          if (isGuage) {
            return chart.update(newValue, {
              total: calculateTotal(newValue)
            }, true);
          } else {
            return chart.update(newValue);
          }
        });
      }
    });
    return $(this);
  };
}
